import { Component } from '@angular/core';
import { SidebarComponent } from 'web-common/src/app/sidebar/sidebar.component';

@Component({
    selector: 'app-admin-invite-sidebar',
    templateUrl: './admin-invite-sidebar.component.html',
    styleUrls: ['./admin-invite-sidebar.component.less', '../../../node_modules/web-common/src/app/sidebar/sidebar.component.less'],
    standalone: false
})
export class AdminInviteSidebarComponent extends SidebarComponent {

}
